export default __webpack_public_path__ + "static/media/search-user-no-result.d6d848b2.svg";